export default {"src":"/_next/static/media/icone-potential.9a2ea519.svg","height":18,"width":32,"blurWidth":0,"blurHeight":0};